export class NotValidSubscriptionIdException extends Error {
  constructor(message?: string) {
    const _defaultMessage = 'Not valid subscription id';

    super(message ?? _defaultMessage);
    this.name = 'NotValidSubscriptionIdExeptions';
  }
}
